import axiosHttp from "services/axiosHttp";
import PermissionManager from "utils/class/PermissionManager";
import { USER } from "constants/AuthConstant";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchSalesReps = createAsyncThunk("fetchSalesReps", async () => {
	const user = PermissionManager.getItem(USER)?.user;
	const channel_id = user?.user_channel?.[0]?.channel_uuid;
	if (!channel_id) throw new Error("Channel ID not found");
	const response = await axiosHttp.get(`payment/request/reps`);
	return response.data.data;
});

const SalesRepsSlice = createSlice({
	name: "SalesRepsSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchSalesReps.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchSalesReps.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchSalesReps.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default SalesRepsSlice.reducer;
